module.exports = __webpack_public_path__ + "static/media/icon_bebes-criancas.198b70c9.svg";